import * as t from "io-ts";

export type FormProperty =
  | number
  | string
  | boolean
  | FormPropertyObject
  | FormProperty[];
export type FormPropertyOutput =
  | number
  | string
  | boolean
  | FormPropertyObjectOutput
  | FormPropertyOutput[];
const FormProperty: t.Type<FormProperty, FormPropertyOutput> =
  t.recursion("FormProperty", () => t.union([
    t.number,
    t.string,
    t.boolean,
    FormPropertyObject,
    t.array(FormProperty),
  ]));

export type FormPropertyObject = { [key in string]: FormProperty };
export type FormPropertyObjectOutput = { [key in string]: FormPropertyOutput };
const FormPropertyObject: t.Type<FormPropertyObject, FormPropertyObjectOutput> =
  t.recursion("FormPropertyObject", () =>
    t.record(t.string, FormProperty));

export type FormProperties = FormPropertyObject
export type FormPropertiesOutput = FormPropertyObjectOutput
export const FormProperties = FormPropertyObject
